<template>
  <div v-if="fileUrl" class="detail-pdf-entry" :class="{ 'detail-pdf-entry-night': night }" @click="openFile">
    <div class="detail-pdf-icon">
      <img src="@/assets/images/icon-pdf.png" alt="" />
    </div>
    <span class="detail-pdf-label">{{ label }}</span>
    <span class="detail-pdf-action">查看</span>
  </div>
</template>

<script>
export default {
  name: 'DetailPdfEntry',
  props: {
    fileUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '点击查看 PDF 原文',
    },
    night: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fileType() {
      const path = this.fileUrl.split('?')[0];
      const suffix = path.split('.').pop();
      return suffix ? suffix.toUpperCase() : 'PDF';
    },
  },
  methods: {
    openFile() {
      const params = {
        filetype: this.fileType,
        url: this.fileUrl,
        title: this.title,
      };
      if (this.$app && typeof this.$app.downloadFile === 'function') {
        this.$app.downloadFile(params);
        return;
      }
      window.open(this.fileUrl, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.detail-pdf-entry {
  display: flex;
  align-items: center;
  height: 40px;
  margin-top: 20px;
  padding: 0 12px;
  border-radius: 4px;
  background-color: #f5f6f6;
  color: #333333;
  font-size: 14px;
  line-height: 40px;
  box-sizing: border-box;
}

.detail-pdf-icon {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  margin-right: 10px;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.detail-pdf-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-pdf-action {
  flex: 0 0 auto;
  margin-left: 10px;
  color: #4e88ff;
}

.detail-pdf-entry-night {
  background-color: #252525;
  color: @dark-color-text-primary;

  .detail-pdf-action {
    color: #497de6;
  }
}
</style>
